export default "__VITE_ASSET__1e436068__"